import { comments } from '@/mocks/homeData';

export default function SectionComments() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3">真实反馈</span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">观众口碑</h2>
          <p className="text-foreground-500 text-sm mt-3 max-w-xl mx-auto">来自高清影视在线观看用户的真实评价</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 max-w-5xl mx-auto">
          {comments.map((comment, idx) => (
            <div key={idx} className="bg-background-50 rounded-2xl p-5 md:p-6 border border-background-200/70">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                  <img src={comment.avatar} alt={comment.name} className="w-full h-full object-cover" loading="lazy" />
                </div>
                <div className="min-w-0">
                  <div className="text-sm font-semibold text-foreground-900">{comment.name}</div>
                  <div className="text-xs text-foreground-400">{comment.date}</div>
                </div>
                <div className="flex items-center gap-0.5 ml-auto flex-shrink-0">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <i key={i} className={`text-xs ${i < comment.rating ? 'text-primary-500 ri-star-fill' : 'text-foreground-300 ri-star-line'}`}></i>
                  ))}
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{comment.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}